<template>
    <div class="breadcrumbs" v-if="items.length > 0">
        <ul class="breadcrumbs__list flex nolist v-center">
            <template v-for="(item, i) in items">
                <template v-if="i < items.length - 1">
                    <li class="breadcrumbs__item" :key="i">
                        <a :href="item.LINK" class="breadcrumbs__link">{{ item.TITLE }}</a>
                    </li>
                </template>
                <template v-else>
                    <li class="breadcrumbs__item breadcrumbs__item--current" :key="i">
                        <span class="breadcrumbs__link">{{ item.TITLE }}</span>
                    </li>
                </template>
            </template>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Breadcrumbs',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    setup: (ctx, props) => {
        return {

        }
    },
}
</script>

<style lang="scss">
    .breadcrumbs {
        &__item {
            font-size: 14px;
            line-height: 20px;
            color: var(--c-gray-500);
            @include tablet {
                font-size: 12px;
                line-height: 16px;
            }
            &::after {
                content: '/';
                margin: 0 0.25em;
            }
            &:last-child {
                &::after {
                    content: '';
                    margin: 0;
                }
            }
        }
        &__link {
            color: var(--c-gray-500);
        }
    }
</style>